import React from 'react';
import { BasicInput, FieldInputProps } from './BasicInput';

export const NumberInput = ({
  value,
  onChange,
  ...rest
}: FieldInputProps<number>): JSX.Element => {
  const handleNumberChange = (fieldValue: string) => {
    if (onChange) {
      onChange(parseFloat(fieldValue));
    }
  };

  return (
    <BasicInput
      inputType="number"
      {...rest}
      value={value !== undefined ? value.toString() : undefined}
      onChange={handleNumberChange}
    />
  );
};
